import Config from '../Config';
//import Moment from 'react-moment';
import 'moment-timezone';

var moment = require('moment-timezone');


class FX {
  static getBase64Image(img) {
    // Create an empty canvas element
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;

    // Copy the image contents to the canvas
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    // Get the data-URL formatted image
    // Firefox supports PNG and JPEG. You could check img.src to
    // guess the original format, but be aware the using "image/jpg"
    // will re-encode the image.
    var dataURL = canvas.toDataURL("image/png");

    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  static load(app, target, callback, payload, no_wait) {
    console.log( app );
    console.log(this);
    console.log(payload);
    /*
     *
    console.log(files);

    if(0){
        var d = document.querySelectorAll('.img_new');
        for (var i = 0; i < d.length; i++){
            var formData = new FormData();
            formData.append("img[" + i + ']', files);
            var img = d[i];
            var inu = FX.getBase64Image(img);
            console.log(formData);
            console.log(inu);
        }
    }
    */


    var method = 'GET';
    var data = '';
    if(payload && payload.method){
      method = payload.method;
      data = payload.data;
    }

    if(!no_wait) app.setState({waiting: true});
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      var DONE = 4;
      var OK = 200;
      if (xhr.readyState === DONE) {
        if(!no_wait) app.setState({waiting: false});


        if (parseInt(xhr.status, 10) === OK) {
          try{
            var res = JSON.parse(xhr.responseText);
            if(typeof callback === 'function'){
              callback(res);
            }
          }
          catch(e ) {
            console.log(e);
            console.log(xhr.responseText);
          }
        }
        else if (xhr.status) {
          console.log(xhr.status);
        }
      };
    }
    if(target.substr(0,4) === 'http'){
        console.log(target);
        xhr.open(method, target);
    }
    else if(target.substr(0,3) !== '|||'){
        console.log(app.paths.apiHost + '/' + target);
        xhr.open(method, app.paths.apiHost + '/' + target);
    }
    else {
        console.log( window.location.origin + '/' + target.substr(3));
        xhr.open(method, window.location.origin + '/' + target.substr(3));
    }
    xhr.setRequestHeader("X-Token-Sec", localStorage.token);
    console.log(no_wait);
    if(!no_wait) app.setState({wating:true});
    if(data){
      xhr.send(JSON.stringify(data));
    }
    else {
      xhr.send();
    }
  }
  static numberFix(value, float) {
      if(value.length && (( float !== true || (value.match(/\./g) || []).length !== 1 ) ||  (value.match(/[^0-9.]/g) || []).length )){
        if (isNaN( value )) {
          value = 0;
        }
        else {
          if(float === true){
            value = (parseFloat(value,10));
          }
          else {
            value = (parseInt(value,10));
          }
        }
      }
      return value;
  }
  static limit() {
    console.log(arguments);
    //console.log(e);
    console.log(arguments.length);
    var e = arguments[arguments.length-1];
    console.log(e);
    console.log(e.target.value);
    console.log(parseInt(e.target.value,10));
    console.log(parseInt(e.target.dataset.max,10));
    console.log(!isNaN(parseInt(e.target.value,10)));
    if(parseInt(e.target.dataset.max,10) < parseInt(e.target.value,10) || (e.target.value && isNaN(parseInt(e.target.value,10)))){
      e.target.value = parseInt(e.target.dataset.max,10);
    }
    else if (e.target.value && !isNaN(parseInt(e.target.value,10))) {
      e.target.value = parseInt(e.target.value,10);
    }
    else if (e.target.value) {
      console.log('test');
      e.target.value = 0;
    }
    if(arguments.length > 1){
      if(typeof arguments[0] === 'function'){
        arguments[0](e);
      }
    }
  }
  static urlRetrieve( state ){

    console.log(this);

    console.log(window.location);

    console.log(this.props.root.state.current_customer);



    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    console.log(x);
    if(0 <= Config.panels.indexOf(x[0]) && this.props.root.state.customer_id){
      state.panel = x[0];
      //var found = false;
      if(x[1]){
        console.log(parseInt(x[1],10));

        this.retrieveDetail(parseInt(x[1],10));
      /*
        state.current_customer[x[0]].list.some(
        (ping) => {
          if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
            state.detail = ping;
            return true;
          }
          return false;
        }
        );
        */
      }

  }
 }
  static nav( panel, id){
    console.log( this );
    FX.load(this, panel + '/' + id , (res, i) => {
      console.log(res.order);
      if(res.order && res.id){
        this.props.root.setState({ detail : res.order  });
      }
    });
  }
  static navigate( panel, detail ,newPath , state, mutator, e){
    if(this.changed && this.changed.message){
      if(!window.confirm(this.changed.message)){
        return false;
      }
    }
    else if(this.changed){
      if(!window.confirm('This page has changed are you sure you wish to exit?')){
        return false;
      }
    }
    this.changed = false;
     console.log(e);
     console.log(mutator);
    //this.forceUpdate();
    console.log( this );
    console.log( state );
    if(typeof state !== 'object' || state.panel === undefined){
       if(typeof state === 'object' ){
         e = state;
         console.log(e);
       }
       if(typeof mutator === 'object' && e === undefined){
         e = mutator;
         mutator = false;
       }
       if(e &&  e.which === 2 ) {
          e.preventDefault();
          alert("middle button");
       }
       state = this.state;
    }
    state.panel = panel;
    state.detail = detail;
    window.history.pushState(state, "", newPath);
    if(mutator === true){
        return state;
    }
    else {
        this.setState(state);
    }
    console.log( panel );
    console.log( detail );
  }
  static pad (_int,tgtLength){
     _int = _int.toString();
     while (_int.length < tgtLength){
       _int = "0" + _int;
     }
     return _int;
  }
  static parseDate (date,tz){
      if(date && !(date instanceof Date) && typeof date === 'string'){
        var a = date.split(/[^0-9]/);
        //console.log(a);
        while( a.length < 6){
          console.log(6 - a.length )
          a.push('00');
        }
        //console.log(a);
        if(tz === 'Z'){
            //console.log('utc');
            return new Date(Date.UTC(a[0],a[1]-1,a[2],a[3],a[4],a[5] ));
        }
        else {
            //console.log('evs');
            
            var testDateUtc = moment.utc(date);
            var localDate = moment(testDateUtc).local();
            console.log('Michigan xxx');
            console.log(localDate )
            return localDate.toDate();
            //return new Date (a[0],a[1]-1,a[2],a[3],a[4],a[5] );
        }
      }
      try{
      //console.log(date.getTimezoneOffset());
      }
      catch(e){
      //console.log(e);

      }
      return date;
  }
  static formHandler (tgt, e){
		    console.log(e);
		    console.log(tgt);
		    console.log(this);
		    var state = this.state;
		    state[tgt] = e.target.value;
		    this.setState(state)
		    console.log(this.state[tgt]);
  }
  static handle (target, field, e) {
      var update = {};
      update[field] = e.target.value;
      target.setState(update);

  }
  static doFocus(sen){
		    console.log(this);
		    console.log(sen);
		    console.log(sen.focusTgt);
		     setTimeout(() => {
            if(sen.focusTgt && document.getElementById(sen.focusTgt)){
              document.getElementById(sen.focusTgt).focus();
              if(typeof document.getElementById(sen.focusTgt).setSelectionRange === 'function'){
                  document.getElementById(sen.focusTgt).setSelectionRange(0, document.getElementById(sen.focusTgt).value.length)
              }
              sen.focusTgt = '';
            }
		     }, 20);
  }
  static dateFormat (dateIn, format){
        if (dateIn === undefined || dateIn === null){
          return '';
        }
        var date = this.parseDate(dateIn);
        if (!(date instanceof Date)){
          return '';
        }
        if (isNaN(date.getTime())){
          return dateIn;
        }
        var monthNames = [
          "January", "February", "March",
          "April", "May", "June", "July",
          "August", "September", "October",
          "November", "December"
        ];

        var day = date.getDate();
        //var monthIndex = date.getMonth();
        var monthName = monthNames[date.getMonth()];
        var monthNumber = date.getMonth() + 1;
        var year = date.getFullYear();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        if(!format){
          format = '{H}:{i} {d2}/{m2}/{Y}';
        }
        else if(format === 'php'){
          format = '{Y}-{m2}-{d2} {H}:{i}:{s}';
        }
        else if(format === '{U}'){
          return Math.floor(date / 1000);
        }
        return format.replace('{d}',day)
               .replace('{H}',this.pad(hour,2))
               .replace('{i}',this.pad(minute,2))
               .replace('{s}',this.pad(second,2))
               .replace('{d2}',this.pad(day,2))
               .replace('{M}',monthName)
               .replace('{m}',monthNumber)
               .replace('{m2}',this.pad(monthNumber, 2))
               .replace('{Y}',year);
  }
  static defend(e){
    e.preventDefault();
    e.stopPropagation();
  }
  static loadDefaultData(App){
    this.load(App, '|||/default/paths.json', (ex)=> {
        App.paths = ex;
        console.log('x');
        this.load(App, 'loginData', (ex)=> {
            console.log(ex);
            if(ex.authenticated){
                App.setState(ex)
            }
            else{
                localStorage.token = '';
                App.setState(ex)
            }
        });
    });
  }
  static encodeQueryData(data,q) {
     let ret = [];
     for (let d in data) {
       ret.push(encodeURIComponent(d) + '=' + data[d]); //encodeURIComponent(data[d]));
     }
     if(q) {
      q = '?';
     }
     else {
      q = '';
     }
     return q + ret.join('&');
   }
   static ucfirst (string) {
      if (string){
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
   }
   static validateAddress(address){
     if (address){
      if( ["AO","AG","AW","SH","BS","BZ","BJ","BW","BO","BQ","BF","BI","CM","CF","KF","CG","CD","CK","CI","CW","DJ","DM","TL","GQ","ER","FJ","TF","GM","GA","GH","GD","GY","HM","HK","KI","LY","MO","MW","ML","MR","NR","AN","NU","KP","QA","RW","KN","ST","SC","SL","SB","SR","SY","TL","TG","TK","TO","TV","UG","AE","VU","YE","ZW"].indexOf(address.country_code) ===-1){
      return ((address.forename || address.surname || address.company) &&
	    (!!address.line_1) &&
	    (!!address.city) &&
	    (!!address.country_code) &&
	    (!!address.postcode))
	    }
	    else {
      return ((address.forename || address.surname || address.company) &&
	    (!!address.line_1) &&
	    (!!address.city) &&
	    (!!address.country_code))
	    
	    }
	   }
	   else {
	   
	      return false;
	   }
    }
    static postcodeFormat (postcode, country_code){
        if(postcode && typeof postcode === 'string' && country_code === "GB"){
            return postcode.replace(" ", "").substr(0, postcode.replace(" ", "").length -3);
        }
        return postcode
    }
    static phoneFormat (no){
       if(no && typeof no === "number" && no.toString().length === 10){
          no = "0" + no.toString().substr(0,4) + ' ' + no.toString().substr(4);
       }
       if(no && typeof no === "number" && no.toString().length === 12){
          no = "+" + no.toString().substr(0,2) + ' (0) ' + no.toString().substr(3,6) + ' ' + no.toString().substr(7);
       }
       return no;
     }
     static status( tgt , value ){
       var statusText = '';
       Config.options[tgt].some( stat => {
         if(stat.id === value ){
           statusText = stat.description;
           return true;
         }
         return false;
       })
       return statusText;
     }
}

export default FX;



// WEBPACK FOOTER //
// ./src/functions/functions.js